import BaseModelInstance from './base.model'
import { UserTerm as ModelDefinition } from './model-definitions'
import UserTermService from './../services/UserTerm.service'

class UserTerm extends BaseModelInstance {
  afterSet = (key, value) => {}

  sign = async ipAddress => {
    const res = await UserTermService.sign(this.id(), { accepted_ip: ipAddress })
    if (res && res?.signed_at && res?.userterm_file) {
      this.set('userterm_file', res.userterm_file)
      if (!this.get('userterm_ip')) {
        this.set('userterm_ip', ipAddress)
      }
      return true
    }

    return false
  }

  constructor(attribs) {
    super(ModelDefinition, attribs)
  }
}

export default UserTerm
